import { enableReceiver } from './actions';
import { PAY_MESSAGE_NAME } from './constants';
import logger from './logger';
export function sendPayEndpointMessage(conference, to, url, event) {
    if (!to) {
        logger.warn('Payment: Skip sending payment event. Params:', to);
        return false;
    }
    try {
        conference?.sendEndpointMessage(to, {
            name: PAY_MESSAGE_NAME,
            payUrl: url,
            ...event
        });
        return true;
    }
    catch (error) {
        logger.error('Failed to send EndpointMessage via the datachannels', error);
        return false;
    }
}
export function onPayAPIEvent({ getState, dispatch }) {
    dispatch(enableReceiver());
}
